import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from "@mui/icons-material/Edit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import PersonIcon from "@mui/icons-material/Person";
import Person3Icon from "@mui/icons-material/Person3";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import { object, string } from "yup";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetUserInfoByUserIdResponse } from "../../../models/officePosts.model";
import { UpdateUserRequest } from "../../../models/security.model";
import { UpdateUser } from "../../../services/security.service";
import SwitchCmp from "../../../components/switch/SwitchCmp";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import PersonOffIcon from "@mui/icons-material/PersonOff";

interface Props {
  userInfo: GetUserInfoByUserIdResponse;
  setUpdateService: any;
  defaultPassword: {
    password: string;
  };
}
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },

  // maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  // paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
const userValidation = object().shape({
  firstName: string()
    .ensure()
    .required("لطفا نام را وارد نمایید.")
    .max(150, "نام نباید بیش از ۱۵۰ کاراکتر باشد"),
  lastName: string()
    .ensure()
    .required("لطفا نام خانوادگی را وارد نمایید.")
    .max(150, "نام خانوادگی نباید بیش از ۱۵۰ کاراکتر باشد"),
  username: string()
    .ensure()
    .required("نام کاربری را وارد نمایید")
    .max(150, "نام کاربری نباید بیش از ۱۵۰ کاراکتر باشد"),
  mobileNumber: string()
    .ensure()
    .required("لطفا شماره موبایل را وارد نمایید")
    .min(11, "شماره موبایل را صحیح وارد نمایید"),
});

const UserHeader = ({ userInfo, setUpdateService, defaultPassword }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const [genderValue, setGenderValue] = useState<"Male" | "Female">();
  const [userTypeValue, setUserTypeValue] = useState<any>();
  const [activeUserValue, setActiveUserValue] = useState<any>();
  const [admin, setAdmin] = useState<boolean>();

  const genderOptions = [
    { title: "مرد", id: 1, enumData: "Male" },
    { title: "زن", id: 2, enumData: "Female" },
  ];
  const userTypeOptions = [
    { title: "سیستمی", id: 1, enumData: "true" },
    { title: "غیر سیستمی", id: 2, enumData: "false" },
  ];
  const activeUserOptions = [
    { title: "فعال", id: 1, enumData: "true" },
    { title: "غیر فعال", id: 2, enumData: "false" },
  ];

  useEffect(() => {
    if (openModal) {
      setGenderValue(userInfo?.genderType);
      setActiveUserValue(userInfo?.isActive ? "true" : "false");
      setUserTypeValue(userInfo?.isSystemUser ? "true" : "false");
      setAdmin(userInfo?.isAdmin);
    }
  }, [openModal]);

  const initialValues: UpdateUserRequest = {
    firstName: userInfo?.firstName,
    lastName: userInfo?.lastName,
    username: userInfo?.username,
    mobileNumber: userInfo?.mobileNumber,
    userId: null,
  };

  const handleSelectedGenderDrop = (e: any) => {
    setGenderValue(e.target.value);
  };
  const handleSelectedUserTypeDrop = (e: any) => {
    setUserTypeValue(e.target.value);
  };
  const handleSelectedActiveUserDrop = (e: any) => {
    setActiveUserValue(e.target.value);
  };

  const { mutate: UpdateUserMutate } = useMutation(UpdateUser, {
    onSuccess: (data: boolean) => {
      if (data) {
        // DATA STORE IN STATE
        toast.success("ویرایش با موفقیت انجام گرفت");
        setOpenModal(false);
        setUpdateService(uuid());
      }
    },
    onError: () => {},
  });

  const handleFormSubmit = (values: UpdateUserRequest) => {
    UpdateUserMutate({
      firstName: values.firstName,
      lastName: values.lastName,
      mobileNumber: values.mobileNumber,
      username: values.username,
      isSystemUser: userTypeValue === "true" ? true : false,
      gender: genderValue,
      isActive: activeUserValue === "true" ? true : false,
      userId: userInfo?.id,
      isAdmin: admin,
    });
  };

  const isTrueSet = (prm: string) => {
    return prm?.toLowerCase?.() === "true";
  };

  return (
    <>
      <Grid
        container
        boxShadow={"0px 1px 1px rgba(0,0,0,0.16)"}
        flexDirection={"column"}
        height={"100%"}
        gap={{ xs: "85px", md: "0px" }}
      >
        <Grid item padding={"1rem"} height={"9vh"}>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <AccountCircleIcon
                sx={{
                  color: "#9AAFC4",
                  fontSize: "60px !important",
                  marginLeft: "10px",
                }}
              />
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                  {userInfo?.firstName} {userInfo?.lastName}
                </b>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b
                  style={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    // fontWeight: "bold",
                  }}
                >
                  {userInfo?.genderType === "Male" ? (
                    <>
                      جنسیت: مرد
                      <PersonIcon />
                    </>
                  ) : (
                    <>
                      جنسیت: زن
                      <Person3Icon />
                    </>
                  )}
                </b>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                  شماره موبایل: {userInfo?.mobileNumber}
                </b>
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              {userInfo?.isAdmin && (
                <>
                  <Typography
                    sx={{
                      color: "#01AF43",
                      padding: "5px 7px",
                      borderRadius: "5px",
                    }}
                  >
                    <ManageAccountsOutlinedIcon sx={{ marginLeft: "5px" }} />
                    ادمین
                  </Typography>
                  <span className="seprator_gray"></span>
                </>
              )}
              {userInfo?.isActive ? (
                <Typography
                  sx={{
                    color: "#fff",
                    background: "#01AF43",
                    padding: "5px 7px",
                    borderRadius: "5px",
                  }}
                >
                  <PersonIcon />
                  فعال
                </Typography>
              ) : (
                <Typography
                  sx={{
                    color: "#fff",
                    background: "#E6123D",
                    padding: "5px 10px",
                    borderRadius: "5px",
                  }}
                >
                  <PersonOffIcon />
                  غیر فعال
                </Typography>
              )}

              <span className="seprator_gray"></span>
              <Typography
                sx={{ cursor: "pointer", color: "#1D4A87" }}
                onClick={() => setOpenModal(true)}
              >
                <EditIcon sx={{ marginLeft: "5px" }} />
                ویرایش اطلاعات
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          padding={"1rem"}
          item
          sx={{ background: "rgba(154,175,196,0.15)" }}
        >
          <Grid container justifyContent={"center"} alignItems={"center"}>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                  نوع کاربر: {userInfo?.isSystemUser ? "سیستمی" : "غیر سیستمی"}
                </b>
              </Typography>
            </Grid>
            <Grid item sx={{ marginInline: "4vw" }}>
              {" "}
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                  تاریخ فعالسازی کاربری: {userInfo?.createDatePersian}
                </b>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                  نام کاربری : {userInfo?.username}
                </b>
              </Typography>
            </Grid>
            {defaultPassword.password && (
              <Grid item sx={{ marginRight: "4vw" }}>
                <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                  <b style={{ color: "#1D4A87", fontSize: "1.1rem" }}>
                    رمز عبور پیشفرض : {defaultPassword.password}
                  </b>
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                // marginY={"3rem"}
                // fontSize={"44px"}
              >
                <AccountCircleIcon
                  sx={{ fontSize: "64px", color: "#9AAFC4" }}
                />
              </Typography>
            </Grid>
            <Formik
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              validateOnMount={true}
              validationSchema={userValidation}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"1.5rem"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام"}
                          label={"نام"}
                          required={true}
                          name="firstName"
                          id="firstName"
                          helperText={touched.firstName ? errors.firstName : ""}
                          error={touched.firstName && Boolean(errors.firstName)}
                          onChange={handleChange}
                          value={values.firstName}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام خانوادگی"}
                          label={"نام خانوادگی"}
                          required={true}
                          name="lastName"
                          id="lastName"
                          helperText={touched.lastName ? errors.lastName : ""}
                          error={touched.lastName && Boolean(errors.lastName)}
                          onChange={handleChange}
                          value={values.lastName}
                          onBlur={handleBlur}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"شماره موبایل"}
                          label={"شماره موبایل"}
                          name="mobileNumber"
                          id="mobileNumber"
                          required
                          helperText={
                            touched.mobileNumber ? errors.mobileNumber : ""
                          }
                          error={
                            touched.mobileNumber && Boolean(errors.mobileNumber)
                          }
                          onChange={handleChange}
                          value={values.mobileNumber}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (/^(?![0-9]).*$/.test(e.key)) {
                              if (e.code !== "Backspace")
                                if (e.code !== "Delete") e.preventDefault();
                            }
                          }}
                          inputProps={{ maxLength: 11 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام کاربری"}
                          label={"نام کاربری"}
                          required={true}
                          name="username"
                          id="username"
                          helperText={touched.username ? errors.username : ""}
                          error={touched.username && Boolean(errors.username)}
                          onChange={handleChange}
                          value={values.username}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", gap: "1.5rem" }}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        <Grid
                          item
                          maxWidth={{ xs: "unset", lg: 209 }}
                          //  sx={{ paddingLeft: "10px" }}
                          className="dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            style={
                              {
                                // maxWidth:
                                //   orederStateValue === "DeliveredToCustomer"
                                //     ? "500px"
                                //     : "300px",
                              }
                            }
                            onChange={handleSelectedGenderDrop}
                            value={genderValue}
                            label={"جنسیت*"}
                            options={genderOptions}
                            name="gender"
                            id="gender"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                        <Grid
                          item
                          //  sx={{ paddingRight: "10px" }}
                          maxWidth={{ xs: "unset", lg: 209 }}
                          className="userHeader-dropdown dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            // style={{
                            //   maxWidth: "400px",
                            // }}

                            onChange={handleSelectedUserTypeDrop}
                            value={userTypeValue}
                            label={"نوع کاربر*"}
                            options={userTypeOptions}
                            name="userType"
                            id="userType"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", gap: "1.5rem" }}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        <Grid
                          item
                          maxWidth={{ xs: "unset", lg: 209 }}
                          //  sx={{ paddingLeft: "10px" }}
                          className="dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            style={{
                              paddingRight: "0 !important",
                              // maxWidth: "400px",
                            }}
                            onChange={handleSelectedActiveUserDrop}
                            value={activeUserValue}
                            label={"وضعیت کاربر*"}
                            options={activeUserOptions}
                            name="activeUser"
                            id="activeUser"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                        <Grid
                          item
                          maxWidth={{ xs: "unset", lg: 209 }}
                          className="certificate-switch"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <SwitchCmp
                            Label={"ادمین"}
                            checked={admin!}
                            onChange={(checked: boolean) => {
                              setAdmin(checked);
                            }}
                            onlabel={"بله"}
                            offlabel={"خیر"}
                            colSize="col-lg-6 col-6"
                          />
                        </Grid>
                      </Grid>

                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"center"}
                          gap={"1rem"}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.firstName ||
                                !values.lastName ||
                                !values.username ||
                                !values.mobileNumber ||
                                !genderValue ||
                                !userTypeValue ||
                                !activeUserValue ||
                                (values.firstName === userInfo?.firstName &&
                                  values.lastName === userInfo?.lastName &&
                                  values.username === userInfo?.username &&
                                  values.mobileNumber ===
                                    userInfo?.mobileNumber &&
                                  userInfo?.genderType === genderValue &&
                                  userInfo?.isSystemUser ===
                                    isTrueSet(userTypeValue) &&
                                  userInfo?.isActive ===
                                    isTrueSet(activeUserValue) &&
                                  userInfo?.isAdmin === admin)
                              }
                              className={
                                !values.firstName ||
                                !values.lastName ||
                                !values.username ||
                                !values.mobileNumber ||
                                !genderValue ||
                                !userTypeValue ||
                                !activeUserValue ||
                                (values.firstName === userInfo?.firstName &&
                                  values.lastName === userInfo?.lastName &&
                                  values.username === userInfo?.username &&
                                  values.mobileNumber ===
                                    userInfo?.mobileNumber &&
                                  userInfo?.genderType === genderValue &&
                                  userInfo?.isSystemUser ===
                                    isTrueSet(userTypeValue) &&
                                  userInfo?.isActive ===
                                    isTrueSet(activeUserValue) &&
                                  userInfo?.isAdmin === admin)
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت ویرایش
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenModal(false);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default UserHeader;
